import React, {
  Fragment,
  useEffect,
  useState
} from "react";
import { connect } from "react-redux";
import Async from "react-select/async";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label
} from "reactstrap";
import {
  changePassword,
  clearTransferUserError,
  getAssignableTranferUsersAsyncSelect,
  getSubordinatesUsersAsyncSelect,
  transferUsers,
  transferUsersForm
} from "../../../store/actions";
import { updateForm } from "../../../store/form/actions";

const TransferUsersForm = (props) => {

  const { handleClose, userId, organisationId, form } = props;
  const [selected_users, setSelectedUsers] = useState("");
  const [users, setUsers] = useState("");


  const isSelectedDevices = form && form.formTransfer && form.formTransfer.selection === "Selected";

  useEffect(() => {
    props.updateForm({
      formTransfer: {},
      errors: {}
    })
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      props.clearTransferUserError();
    }
  }, [])


  const handleLoadSubordinates = (inputValue, callback) => {
    if (organisationId) {
      props.getSubordinatesUsersAsyncSelect(organisationId, userId, inputValue, callback)
    }
    else {
      callback([]);
    }
  };

  const handleSubordinateChange = (value) => {
    setUsers(value)
    props.updateForm({
      formTransfer: {
        ...form.formTransfer,
        selected_users: value
      },
      errors: {
        ...form && form.errors,
        selected_user: null,
      }
    });
  };

  const handleLoadUsers = (inputValue, callback) => {
    if (userId && organisationId) {
      props.getAssignableTranferUsersAsyncSelect(userId, organisationId, inputValue, callback)
    }
    else {
      callback([]);
    }
  };

  const handleUserChange = (value) => {
    setSelectedUsers(value)
    props.updateForm({
      formTransfer: {
        ...form.formTransfer,
        selected_user: value
      },
      errors: {
        ...form && form.errors,
        selected_user: null,
      }
    });
  };

  const handleSelectOnChange = (event) => {
    const { name, value } = event.target;
    props.updateForm({
      formTransfer: {
        ...form.formTransfer,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });
  };

  const handleTransferUser = (e) => {
    e.preventDefault();
    const { formTransfer } = form || {};
    const { selected_users, selection, selected_user } = formTransfer || {};
    const currentErrors = {};

    if (!selected_user) {
      currentErrors.selected_user = "Target User is required"
    }
    if (!selection) {
      currentErrors.selection = "Selection is required"
    }
    if (!selected_users && isSelectedDevices) {
      currentErrors.selected_users = "Users is required"
    }

    props.updateForm({
      formTransfer: {
        ...form.formTransfer,
      },
      errors: currentErrors,
    })

    if (Object.keys(currentErrors).length === 0) {
      props.TransferUsers(userId, form.formTransfer);
    }
  };

  return (
    <Fragment>
      <Form onSubmit={handleTransferUser}>
        <FormGroup>
          <Label>
            Target User<span className="text-danger">*</span>
          </Label>
          <Async
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderColor: (form && form.errors && form.errors.selected_user) ? 'red' : "silver"
              })
            }}
            autoFocus
            openMenuOnFocus
            name="select_user"
            placeholder="Select User"
            defaultOptions
            loadOptions={handleLoadUsers}
            onChange={handleUserChange}
            isSearchable={true}
            value={selected_users}
          />
          {(form && form.errors && form.errors.selected_user) &&
            <FormText sx={{ marginLeft: "10px" }}>
              <div className="text-danger">
                {form && form.errors && form.errors.selected_user}
              </div>
            </FormText>
          }
        </FormGroup>
        <FormGroup>
          <Label>
            Selection<span className="text-danger">*</span>
          </Label>
          <Input
            className="form-control"
            name="selection"
            type='select'
            onChange={handleSelectOnChange}
            invalid={form && form.errors && form.errors.selection}
          >
            <option value="">Select</option>
            <option value="All">All Users</option>
            <option value="Selected">Selected Users</option>
          </Input>
          <FormFeedback>
            {form && form.errors && form.errors.selection}
          </FormFeedback>
        </FormGroup>
        {isSelectedDevices && (
          <FormGroup>
            <Label>
              Users<span className="text-danger">*</span>
            </Label>
            <Async
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  borderColor: (form && form.errors && form.errors.selected_users) ? 'red' : "silver"
                })
              }}
              isClearable
              name="selected_users"
              placeholder="Select Users"
              className="vm-react-select"
              isSearchable
              isMulti
              defaultOptions
              loadOptions={handleLoadSubordinates}
              onChange={handleSubordinateChange}
              value={users}
              openMenuOnFocus={true}
            />
            {(form && form.errors && form.errors.selected_users) &&
              <FormText sx={{ marginLeft: "10px" }}>
                <div className="text-danger">
                  {form && form.errors && form.errors.selected_users}
                </div>
              </FormText>
            }
          </FormGroup>
        )}
        <FormGroup>
          <Button
            type="submit"
            className='me-4'
            color="success"
            onClick={handleTransferUser}
          >
            Submit
          </Button>
          <Button
            color="danger"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>

    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  form: state.form.form,
  isPending: state.userdetails.isTransferUserPending,
  errorMessage: state.userdetails.transferErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (transferForm) => dispatch(updateForm(transferForm)),
  transferUsersForm: (transferForm) => dispatch(transferUsersForm(transferForm)),
  changePassword: () => dispatch(changePassword()),
  clearTransferUserError: () => dispatch(clearTransferUserError()),
  getSubordinatesUsersAsyncSelect: (organisationId, userId, searchValue, callback) =>
    dispatch(getSubordinatesUsersAsyncSelect(organisationId, userId, searchValue, callback)),
  getAssignableTranferUsersAsyncSelect: (userId, organisationId, searchValue, callback) =>
    dispatch(getAssignableTranferUsersAsyncSelect(userId, organisationId, searchValue, callback)),
  TransferUsers: (userId, transferForm) => dispatch(transferUsers(userId, transferForm)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferUsersForm);
